//Styles
import * as S from '../DownsellModal.styles';

//Types
import {InclusionsList} from 'hotels/hotels-types/src/details-cg/types';

interface DownsellInclusionListProps {
  linkedInclusionList: InclusionsList[];
}

const DownsellInclusionList = ({linkedInclusionList}: DownsellInclusionListProps) => {
  if (!linkedInclusionList) {
    return null;
  }

  const slicedInclusionList = linkedInclusionList?.slice(0, 3);

  return (
    <S.ThingsNotAvailableSection>
      {slicedInclusionList?.map((linkedInclusion, index) => (
        <S.NonRefundableSection key={`linkedInculsion_${index.toString()}`}>
          {linkedInclusion?.iUrl ? <S.IconImage src={linkedInclusion?.iUrl} /> : null}
          <S.NoMealText>{linkedInclusion?.text}</S.NoMealText>
        </S.NonRefundableSection>
      ))}
    </S.ThingsNotAvailableSection>
  );
};

export default DownsellInclusionList;
